import { Game } from "../types/game";

/** Dialog toolbar — matches Dave mock: "Payment" + game name. */
export function getPaymentDialogTitle(_game: Pick<Game, "code" | "name">): string {
  return "Payment";
}

export function getPaymentDialogSubtitle(game: Pick<Game, "code" | "name">): string {
  return `${game.code} · ${game.name}`;
}
